import { useMemo, useState } from "react";
import { useCalculateCustomerBudgetQuery } from "../../../../api/plamo-api";
import BalanceSheet from "../../fragments/balance-sheet";
import dayjs from "dayjs";
import { Select } from "antd";


function CustomerBalanceSheet({ customer, customerId }: any) {
  const [year, setYear] = useState<number>(dayjs().year());
  const { data: budget, isFetching: budgetsFetching } = useCalculateCustomerBudgetQuery({ id: customerId, year }) as any;

  console.log("Budgets loading", budgetsFetching);

  const budgets = useMemo(() => (budget && !budgetsFetching) ? { [customerId]: budget } : {}, [budget, customerId, budgetsFetching])

  return <>
    <Select options={[{ label: "2025", value: "2025" }, { label: "2026", value: "2026"}]} value={year} onChange={value => setYear(Number(value))} />
    <BalanceSheet customers={customer ? [customer] : []} budgets={budgets} year={year} />
  </>
}

export default CustomerBalanceSheet;